"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _FirstPage = _interopRequireDefault(require("@material-ui/icons/FirstPage"));

var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));

var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));

var _LastPage = _interopRequireDefault(require("@material-ui/icons/LastPage"));

var _Storyblok = _interopRequireDefault(require("../../../../../../../utils/Storyblok"));

var MuiActionsComponent = function MuiActionsComponent(_ref) {
  var count = _ref.count,
      page = _ref.page,
      rowsPerPage = _ref.rowsPerPage,
      onChangePage = _ref.onChangePage,
      rootClass = _ref.rootClass;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  var theme = (0, _styles.useTheme)();

  var handleFirstPageButtonClick = function handleFirstPageButtonClick(e) {
    onChangePage(e, 0);
  };

  var handleBackButtonClick = function handleBackButtonClick(e) {
    onChangePage(e, page - 1);
  };

  var handleNextButtonClick = function handleNextButtonClick(e) {
    onChangePage(e, page + 1);
  };

  var handleLastPageButtonClick = function handleLastPageButtonClick(e) {
    onChangePage(e, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: handleFirstPageButtonClick,
    disabled: page === 0,
    "aria-label": "first page",
    "data-testid": "firstButton"
  }, theme.direction === 'rtl' ? /*#__PURE__*/_react.default.createElement(_LastPage.default, null) : /*#__PURE__*/_react.default.createElement(_FirstPage.default, null)), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: handleBackButtonClick,
    disabled: page === 0,
    "aria-label": "previous page",
    "data-testid": "previousButton"
  }, theme.direction === 'rtl' ? /*#__PURE__*/_react.default.createElement(_KeyboardArrowRight.default, null) : /*#__PURE__*/_react.default.createElement(_KeyboardArrowLeft.default, null)), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: handleNextButtonClick,
    disabled: page >= Math.ceil(count / rowsPerPage) - 1,
    "aria-label": "next page",
    "data-testid": "nextButton"
  }, theme.direction === 'rtl' ? /*#__PURE__*/_react.default.createElement(_KeyboardArrowLeft.default, null) : /*#__PURE__*/_react.default.createElement(_KeyboardArrowRight.default, null)), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: handleLastPageButtonClick,
    disabled: page >= Math.ceil(count / rowsPerPage) - 1,
    "aria-label": "last page",
    "data-testid": "lastButton"
  }, theme.direction === 'rtl' ? /*#__PURE__*/_react.default.createElement(_FirstPage.default, null) : /*#__PURE__*/_react.default.createElement(_LastPage.default, null)));
};

var _default = MuiActionsComponent;
exports.default = _default;
MuiActionsComponent.propTypes = {
  /**
   * stroyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop: -1
   * The total number of rows.
   */
  count: _propTypes.default.number,

  /**
   * mui prop: 0 (item quantity)
   * The zero-based index of the current page.
   */
  page: _propTypes.default.number,

  /**
   * mui prop: 25
   * The number of rows per page.
   */
  rowsPerPage: _propTypes.default.number,

  /**
   * mui prop: 25
   * The number of rows per page.
   */
  // eslint-disable-next-line react/require-default-props
  onChangePage: _propTypes.default.func
};
MuiActionsComponent.defaultProps = {
  count: -1,
  page: 0,
  rowsPerPage: 25,
  rootClass: ['flexShrink: 0']
};